import React from 'react';

function Radio({ id, required = false, className = 'form-check pl-0', label, ...restProps }) {
  return (
    <div className={className}>
      <input className="form-check-input" type="radio" id={id} {...restProps} />
      <label className="form-check-label" htmlFor={id}>
        {label}
        {required ? <span className="requred">*</span> : ''}
      </label>
    </div>
  );
}

export default Radio;
